<template>
    <svg width="16" height="18" viewBox="0 0 16 18"><path fill="#516783" d="M16 9 0 18V0Z"/></svg>
</template>
<script>
export default {
    name: "IconPlay"
}
</script>
 